import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

class QuizinatorWeighted extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ans: null,
            idx: -1,
            cont: false
        };

        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        let quiz = this.props.quiz,
            question = this.props.quiz.questions[this.props.currentQuestionIndex],
            htmlQuestion = function () {
                return { __html: question.question };
            },
            answerButtons = question.answers.map((answer, i) =>
                <Col key={i} lg={12}>
                    <Form.Check label={answer}
                        key={`chk_${i}_${question.id || ''}`}
                        name='pickOne'
                        onChange={(e) => {
                            let ans = e.target.id.split('|');
                            this.setState({ans: {v: ans[1], i: parseInt(ans[0])}, cont: true});
                        }}
                        type={'radio'} id={`${i}|${answer}`} />
                </Col>
        );

        return (
            <section className={'quizSection' + (this.props.buttonsDisabled ? ' transitionOut' : '')}>
                {this.props.introText &&
                    <div className="questionIntro">
                        <p>{this.props.introText}</p>
                    </div>
                }
                <div className="questionNumber">Question {this.props.currentQuestionIndex + 1} / {quiz.questions.length}</div>
                <div className="question">
                    <div dangerouslySetInnerHTML={htmlQuestion()} />
                </div>
                <div className="answers">
                    <Row>
                        {answerButtons}
                    </Row>
                    <br/>
                    <button onClick={this.handleClick.bind(this)} className={(!this.state.cont)?'disabled':''} disabled={!this.state.cont}>Next</button>
                </div>
            </section>
        );
    }

    handleClick(event) {
        let { ans } = this.state;
        let answer = { value: ans.i },
            target = event.currentTarget;

        this.props.submitAnswer(answer);

        target.classList.add('clicked');

        let that = this;
        window.setTimeout(function () {
            target.classList.remove('clicked', 'correct', 'incorrect');

            that.setState({cont: false, ans: null, idx:-1});
        }, this.props.transitionDelay);
    }
}

export default QuizinatorWeighted;